/**
 * Add Player Modal - Form for creating new players
 */

import { closeOnBackdropClick } from "../utils/ui";
import { renderPlayerFormCard, validatePlayerForm } from "./playerForm";

export class AddPlayerModal {
  private modal: HTMLDivElement;
  private resolve: ((value: any) => void) | null = null;

  constructor() {
    this.modal = document.createElement("div");
    this.setupModal();
  }

  private setupModal() {
    this.modal.className =
      "hidden fixed inset-0 bg-slate-900/80 backdrop-blur-sm flex items-center justify-center z-50 p-4";
    this.modal.innerHTML = renderPlayerFormCard({
      title: "Add New Player",
      formId: "addPlayerForm",
      nameLabel: "Player Name *",
      namePlaceholder: "e.g., John Doe",
      nameRequired: true,
      submitIcon: "person_add",
      submitLabel: "Add Player",
    });

    document.body.appendChild(this.modal);
    this.attachEventListeners();
  }

  private attachEventListeners() {
    const form = this.modal.querySelector("#addPlayerForm") as HTMLFormElement;
    const cancelBtn = this.modal.querySelector("#cancelBtn") as HTMLButtonElement;

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.handleSubmit();
    });

    cancelBtn.addEventListener("click", () => {
      this.close();
    });

    closeOnBackdropClick(this.modal, () => this.close());
  }

  private handleSubmit() {
    const nameInput = this.modal.querySelector("#playerName") as HTMLInputElement;
    const levelInput = this.modal.querySelector("#playerLevel") as HTMLSelectElement;
    const errorDiv = this.modal.querySelector("#errorMessage") as HTMLDivElement;

    const name = nameInput.value.trim();
    const level = parseInt(levelInput.value);

    const error = validatePlayerForm(name, level);
    if (error) {
      errorDiv.textContent = error;
      errorDiv.classList.remove("hidden");
      return;
    }

    const data = {
      name,
      level,
    };

    this.close();
    if (this.resolve) {
      this.resolve(data);
    }
  }

  private close() {
    this.modal.classList.add("hidden");
    this.clearForm();
  }

  private clearForm() {
    const form = this.modal.querySelector("#addPlayerForm") as HTMLFormElement;
    form.reset();
    const errorDiv = this.modal.querySelector("#errorMessage") as HTMLDivElement;
    errorDiv.classList.add("hidden");
  }

  show(): Promise<{
    name: string;
    level: number;
  } | null> {
    return new Promise((resolve) => {
      this.resolve = resolve;
      this.modal.classList.remove("hidden");
      const nameInput = this.modal.querySelector("#playerName") as HTMLInputElement;
      nameInput.focus();
    });
  }
}
